<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height column  ma-0 pt-0>
        
        <scroll-area>
          
          <template slot="body">

            <v-layout shrink>
              <v-layout fill-height justify-start>
                <v-flex xs7 pa-0>
                  <v-layout fill-height justify-start>
                    <v-flex xs3 pa-0>
                      <v-tooltip dark color="secondary" right>
                        <v-btn :data-testid="$options.name + 'v-btn' + 'createDefaultCert'" block :disabled="checkRules" small slot="activator" color="accent"
                          @click="() => createDefaultCert()" 
                          >
                          <v-layout fill-height justify-start align-center py-0>
                            <v-flex shrink pr-1 pt-2>
                              <svg-icon
                                color="white"
                                :name="'certificate_reissue'"
                                width="18"
                              />
                            </v-flex>
                            <v-layout fill-height justify-start align-center pt-1>
                              <span>{{$t('reissue sertificate (CA)')}}</span>
                            </v-layout>
                          </v-layout>
                        </v-btn>
                        <span>{{ $t('reissue sertificate (CA)') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>

            <v-layout mb-2 mt-2 px-0>
              <v-layout class="title toolbar_castom" style="height: 50px; background-color: #FBDCCA" >
                <v-flex shrink pl-2>
                  <svg-icon
                    color="secondary"
                    :name="'undefined'"
                    width="34"
                  />
                </v-flex>
                <v-layout column fill-height>
                  <v-layout align-end justify-start px-2>
                    <span class="body-2">{{ $t('Создание нового сертификата') }}</span>
                  </v-layout>
                  <v-layout align-start justify-start px-2>
                    <span class="caption secondary--text">{{ $t('Приведет к замене корневого сертификата системы') }}</span>
                  </v-layout>
                </v-layout>                
              </v-layout>
              <v-flex xs6 ></v-flex>
            </v-layout>

            <v-layout shrink justify-start mb-3 >
              <v-layout column  justify-start >
                <v-layout column shrink pt-2>

                  <v-layout style="height: 40px" px-0 pb-3>
                    <v-layout fill-height class="title">
                      <v-layout align-center justify-start px-0>
                        <span class="body-2">{{ $t('Идентификация CA') }}</span>
                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ИМЯ СЕРТИФИКАТА (CN)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        append-icon="star_outline"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'publisher.cn'"
                        v-model="model.obj.cn"
                        :rules="[maxLength]"
                        :required="true"
                        maxlength="64"
                        light
                        outline
                        flat
                        class="white"
                        hide-details
                        :rows="1"
                        color=""
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ОРГАНИЗАЦИЯ (О)')"
                        append-icon="star_outline"
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'publisher.o'"
                        v-model="model.obj.o"
                        light
                        outline
                        flat
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ПОДРАЗДЕЛЕНИЕ (OU)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'publisher.ou'"
                        v-model="model.obj.ou"
                        light
                        outline
                        flat
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                </v-layout>

                <v-layout column shrink pt-3>

                  <v-layout style="height: 40px" px-0 py-3>
                    <v-layout fill-height class="title">
                      <v-layout align-center justify-start px-0>
                        <span class="body-2">{{ $t('Адрес / Местонахождение') }}</span>
                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('СТРАНА (С)')"
                        append-icon="star_outline"
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'publisher.c'"
                        v-model="model.obj.c"
                        light
                        outline
                        flat
                        :rules="[minLength]"
                        :required="true"
                        validate-on-blur
                        maxlength="2"
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('РЕГИОН / ОБЛАСТЬ (ST)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'publisher.st'"
                        v-model="model.obj.st"
                        light
                        outline
                        flat
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ГОРОД (l)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'publisher.l'"
                        v-model="model.obj.l"
                        light
                        outline
                        flat
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                </v-layout>
              </v-layout>
              
              <v-flex xs6></v-flex>
            </v-layout>

          </template>

        </scroll-area>

      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface CertificateData {
  cn: string | null
  o: string | null
  c: string | null
  st: string | null
  l: string | null
  ou: string | null
}

interface ModelData {
  obj: CertificateData
}

export default Vue.extend({
  name: 'SERTIFICATES-REISSUE',

  components: {
    scrollArea,
    svgIcon,
  },

  props: {},

  data(): {
    model: ModelData
  } {
    return {
      model: {
        obj: {
          cn: null,
          o: null,
          c: null,
          st: null,
          l: null,
          ou: null,
        },
      },
    }
  },

  computed: {
    checkRules(): boolean {
      let resp = false
      if (this.model.obj.cn && this.model.obj.cn.length > 64) {
        resp = true
      }
      if (!this.model.obj.c || this.model.obj.c?.trim().length !== 2) {
        resp = true
      }
      if (!this.model.obj.c?.trim() || !this.model.obj.o?.trim() || !this.model.obj.cn?.trim()) {
        resp = true
      }
      return resp
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      // Метод предназначен для переопределения при необходимости
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    async createDefaultCert(): Promise<void> {
      try {
        console.log('SERTIFICATES-REISSUE', 'createDefaultCert')
        const params = this.model.obj
        await this.$bridge.customQuery('core', 'certs/createCert', params, 'post')
      } catch (error) {
        console.error('SERTIFICATES-REISSUE', 'createDefaultCert smth wrong', error)
      }
    },

    setErrorMessage(err: string): boolean {
      this.$dialog.notify.error(err, { timeout: 1000 })
      return false
    },

    required(v: any): boolean {
      if (!!v) return true
      this.setErrorMessage('Поле должно быть заполнено')
      return false
    },

    maxLength(v: string): boolean {
      if (!v || v.length <= 64) return true
      this.setErrorMessage('Поле не может содержать более 64 символов')
      return false
    },

    minLength(v: string): boolean {
      if (v) {
        console.log('VTRiM()', v.trim().length)
      }
      if (!v || (v.length === 2 && v.trim().length === 2)) {
        return true
      }
      this.setErrorMessage('Поле СТРАНА (С) должно содержать 2 символа')
      return false
    },

    reset(): void {
      this.model = {
        obj: {
          cn: null,
          o: null,
          c: null,
          st: null,
          l: null,
          ou: null,
        },
      }
    },
  },
})
</script>

<style lang="css" scoped>
.toolbar_castom {
    border: solid 1px #9F9F9F ;
    border-radius: 2px;
    /* background-color: #D4EEFC */
  }
</style>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            width: 100%
            height: 100%
            /* min-width: 100%
            min-height: 100% */

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
